<template>
	<v-container class="pt-4">

		<v-row justify="center">
			<v-col cols="12" sm="8" md="6" lg="4">

	  		<v-card class="mx-auto px-4 mb-n16  transparent elevation-0 " align="center" style="z-index: 1;">
          <v-avatar
            size="180"
            color="transparent"
          >
            <avataaars
            	v-if="getAvatar != null"
	          	:accessoriesType="getAvatar.accessoriesType"
		        	:isCircle="true"
				      :clotheType="getAvatar.clotheType"
		        	:clotheColor="getAvatar.clotheColor"
				      :eyebrowType="getAvatar.eyebrowType"
				      :eyeType="getAvatar.eyeType"
				      :facialHairColor="getAvatar.facialHairColor"
		        	:facialHairType="getAvatar.facialHairType"
				      :graphicType="getAvatar.graphicType"
				      :mouthType="getAvatar.mouthType"
		        	:skinColor="getAvatar.skinColor"
		        	:topType="getAvatar.topType"
		        	:topColor="getAvatar.topColor"
				      :hairColor="getAvatar.hairColor"
				      :circleColor="'#6fb8e0'">
				    </avataaars>

				    <avataaars v-else></avataaars>

          </v-avatar>

          <v-btn
          	absolute
          	bottom
          	color="primary"
          	small
          	@click="avatarParamentro.editar = true"
          	fab
          	class="text-capitalize mb-4"
          >
          	<v-icon small>mdi-pencil</v-icon>
        	</v-btn>
			  </v-card>

			  <v-card  class="shadowCard  separacionAlta text-center pb-4">
	  			<div>
            <div class="mb-0 font-weight-bold colorCurso text-body-1" >
             	<strong>{{ getUsuarioLMS.nombre_completo }}</strong>
            </div>

            <p class="mb-0 font-weight-bold">
              <strong>{{ getUsuarioLMS.usuario }}</strong>
            </p>
          </div>

	  		  <v-divider class="ma-0 mt-4"></v-divider>

	  		  <v-window
			      v-model="seccionMenu"
			    >
			      <v-window-item>
			        <v-card-actions class="py-4 pb-0">
			  		  	<v-spacer></v-spacer>
			  		  	<v-card class="text-center elevation-0 transparent">
			  		    	<v-btn color="primary" fab small @click="habilitarVentana( 1 )"><v-icon>mdi-account</v-icon></v-btn>
			  		  	  <v-card-text>
			  		  	    Mi cuenta
			  		  	  </v-card-text>
			  		  	</v-card>

			  		  	<v-spacer></v-spacer>
			  		  	<v-card class="text-center elevation-0 transparent">
			  		    	<v-btn color="secondary" fab small @click="habilitarVentana( 2 )"><v-icon>mdi-lock</v-icon></v-btn>
			  		  	  <v-card-text>
			  		  	    Contraseña
			  		  	  </v-card-text>
			  		  	</v-card>

			  		  	<v-spacer></v-spacer>
			  		  	<v-card class="text-center elevation-0 transparent">
			  		    	<v-btn color="purple" dark fab small @click="habilitarVentana( 3 )"><v-icon>mdi-map-marker</v-icon></v-btn>
			  		  	  <v-card-text>
			  		  	    Dirección
			  		  	  </v-card-text>
			  		  	</v-card>
			  		  	<v-spacer></v-spacer>
			  		  </v-card-actions>
			      </v-window-item>

			      <v-window-item>
			        <v-card-actions class="py-4 pb-0">
			        	<v-spacer></v-spacer>
			  		  	<v-card class="text-center elevation-0 transparent">
			  		    	<v-btn color="#1B5E20" dark fab small :to="{name: 'Certificados'}"><v-icon>mdi-school</v-icon></v-btn>
			  		  	  <v-card-text>
			  		  	    Certificados
			  		  	  </v-card-text>
			  		  	</v-card>

			  		  	<v-spacer></v-spacer>
								<v-card class="text-center elevation-0 transparent">
									<v-btn color="orange" dark fab small @click="habilitarVentana(7)"><v-icon>mdi-file-document</v-icon></v-btn>
									<v-card-text>
										Reglamento
									</v-card-text>
								</v-card>

			  		  	<v-spacer></v-spacer>
			  		  	<v-card class="text-center elevation-0 transparent">
			  		    	<v-btn color="pink" dark fab small :to="{name: 'Kardex'}"><v-icon>mdi-file-document</v-icon></v-btn>
			  		  	  <v-card-text>
			  		  	    Kardex
			  		  	  </v-card-text>
			  		  	</v-card>
			  		  	<v-spacer></v-spacer>
			  		  </v-card-actions>

              <v-card-actions class="py-4 pb-0">
                  <v-spacer></v-spacer>
                  <v-card class="text-center elevation-0 transparent">
                    <v-btn color="#004F72" dark fab small :to="{ name: 'Recomendados' }"><v-icon>mdi-account-group</v-icon></v-btn>
                    <v-card-text>
                      Recomendados
                    </v-card-text>
                  </v-card>
                  <v-spacer></v-spacer>
                  <v-card class="text-center elevation-0 transparent">
                    <v-btn color="primary" fab small @click="habilitarVentana( 8 )"><v-icon>mdi-account</v-icon></v-btn>
                    <v-card-text>
                      Datos Fiscales
                    </v-card-text>
                  </v-card>
                  <v-spacer></v-spacer>
                </v-card-actions>
			      </v-window-item>


			      <v-window-item>
			        <v-card-actions class="py-4 pb-0">
			  		  	<v-spacer></v-spacer>
			  		  	<v-card class="text-center elevation-0 transparent">
			  		    	<v-btn color="#004F72" dark fab small @click="habilitarVentana( 4 )"><v-icon>mdi-clipboard-edit</v-icon></v-btn>
			  		  	  <v-card-text>
			  		  	    EXCI
			  		  	  </v-card-text>
			  		  	</v-card>

			  		  	<v-spacer></v-spacer>
			  		  	<v-card class="text-center elevation-0 transparent">
			  		    	<v-btn color="#00E2F1" dark fab small @click="habilitarVentana( 5 )"><v-icon>mdi-clipboard-edit</v-icon></v-btn>
			  		  	  <v-card-text>
			  		  	    TOEFL
			  		  	  </v-card-text>
			  		  	</v-card>

								<v-spacer></v-spacer>
			  		  	<v-card class="text-center elevation-0 transparent">
			  		    	<v-btn color="pink" dark fab small :to="{name: 'MisIncidencias'}"><v-icon>mdi-account-alert</v-icon></v-btn>
			  		  	  <v-card-text>
			  		  	    Mis incidencias
			  		  	  </v-card-text>
			  		  	</v-card>
			  		  	<v-spacer></v-spacer>

			  		  </v-card-actions>

              <v-card-actions>

                <v-spacer></v-spacer>

                <v-card class="text-center elevation-0 transparent">
                  <v-btn color="purple" dark fab small :to="{ name: 'MisFacturas' }"><v-icon>mdi-file-document</v-icon></v-btn>
			  		  	  <v-card-text>
                    Mis Facturas
			  		  	  </v-card-text>
			  		  	</v-card>

                <v-spacer></v-spacer>

                <v-card class="text-center elevation-0 transparent">
                  <v-btn color="blue" dark fab small :to="{ name: 'MisConstancias' }"><v-icon>mdi-file-document</v-icon></v-btn>
			  		  	  <v-card-text>
                    Solicitar Constancias
			  		  	  </v-card-text>
			  		  	</v-card>

                <v-spacer></v-spacer>

              </v-card-actions>

			      </v-window-item>

			      <v-window-item>
			        <v-card-actions class="py-4 pb-0">
			  		  	<v-spacer></v-spacer>
			  		  	<v-card class="text-center elevation-0 transparent">
			  		    	<v-btn color="#FF6D00" dark fab small :to="{name: 'Diccionario'}"><v-icon>mdi-google-translate</v-icon></v-btn>
			  		  	  <v-card-text>
			  		  	    Diccionario
			  		  	  </v-card-text>
			  		  	</v-card>

			  		  	<v-spacer></v-spacer>
			  		  	<v-card class="text-center elevation-0 transparent">
			  		    	<v-btn color="purple darken-1" dark fab small :to="{name: 'Calendarios'}"><v-icon>mdi-calendar</v-icon></v-btn>
			  		  	  <v-card-text>
			  		  	    Calendario
			  		  	  </v-card-text>
			  		  	</v-card>

			  		  </v-card-actions>
			      </v-window-item>
			    </v-window>

	  		  <v-card-actions class="justify-space-between">
	  		  	<!-- Anterior -->
			      <v-btn
			        text
			        @click="prev"
			      >
			        <v-icon>mdi-chevron-left</v-icon>
			      </v-btn>
			      <v-item-group
			        v-model="seccionMenu"
			        class="text-center"
			        mandatory
			      >
			        <v-item
			          v-for="n in length"
			          :key="`btn-${n}`"
			          v-slot="{ active, toggle }"
			        >
			          <v-btn
			            :input-value="active"
			            icon
			            @click="toggle"
			          >
			            <v-icon small>mdi-record</v-icon>
			          </v-btn>
			        </v-item>
			      </v-item-group>
			      <!-- Siguiente -->
			      <v-btn
			        text
			        @click="next"
			      >
			        <v-icon>mdi-chevron-right</v-icon>
			      </v-btn>
			    </v-card-actions>

			    <div>
				    <v-btn
	            color="primary"
	            text
	            @click="dialogAvisoPrivacidad = true"
	          >
	            Aviso de Privacidad
	          </v-btn>
	        </div>

	  		</v-card>
	  	</v-col>

	  	<v-col cols="12" sm="8" md="6" lg="4" class="pt-4 px-1">
		  	<MiCuenta       v-if="ventana == 1" :perfil="perfil"/>
		  	<Password       v-if="ventana == 2" />
		  	<Direccion      v-if="ventana == 3" :perfil="perfil"/>
		  	<Exci           v-if="ventana == 4" :perfil="perfil"/>
		  	<TOEFL          v-if="ventana == 5" :perfil="perfil"/>
		  	<Notifi         v-if="ventana == 6" :perfil="perfil"/>
				<Reglamento     v-if="ventana == 7" />
        <DatosFiscales  v-if="ventana == 8" :perfil="perfil" :iderp="iderp"/>
	    	<Loader         v-if="cargar"       :loader="loader"/>
	    	<AvataraUsuario v-if="avatarParamentro.editar"   :avatarParamentro="avatarParamentro"/>
	  	</v-col>
	  </v-row>

	  <v-dialog
      v-model="dialogAvisoPrivacidad"
      width="500"
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Aviso de Privacidad
        </v-card-title>

        <v-card-text>
          Este Aviso de Privacidad describe cómo FAST ENGLISH (en adelante "nosotros", "nuestro" o "la Empresa") recopila, utiliza y protege la información personal que recabamos a través de nuestra aplicación móvil.

          <br/>
          <br/>
					<strong>Información que Recopilamos:</strong>
          <br/>
          <br/>

          <ul>
          	<li>
							<strong>Nombre:</strong> Recopilamos su nombre para personalizar la experiencia en nuestra aplicación.
          	</li>
          	<li>
							<strong>Correo Electrónico:</strong> Recopilamos su dirección de correo electrónico para que pueda acceder y utilizar nuestra aplicación. Su correo electrónico también puede ser utilizado para enviarle comunicaciones relacionadas con la aplicación y su uso.
          	</li>
          	<li>
							<strong>Teléfono:</strong> Recopilamos su número de teléfono para fines de contacto en caso de que sea necesario para confirmar pagos o resolver problemas relacionados con su cuenta.
          	</li>
          </ul>
          <br/>
          <br/>

					<b>Uso de la Información:</b>
          <br/>
          <br/>

					Utilizamos la información que recopilamos para los siguientes fines:
          <br/>
          <br/>
          <ul>
          	<li>
							Facilitar su acceso y uso de la aplicación.
          	</li>
          	<li>
							Brindar soporte técnico y atención al cliente.
          	</li>
          	<li>
							Enviar comunicaciones relacionadas con la aplicación y los pagos.
          	</li>
          	<li>
							Mejorar nuestros servicios y personalizar su experiencia.
          	</li>
          </ul>

          <br/>
          <br/>

					<b>Seguridad de la Información:</b>
          <br/>
          <br/>

					Tomamos medidas de seguridad razonables para proteger la información personal que recopilamos. Sin embargo, no podemos garantizar la seguridad completa de la información transmitida a través de Internet o almacenada en nuestra aplicación.
          <br/>
          <br/>

					<b>Compartir Información:</b>
          <br/>
          <br/>

					No vendemos ni compartimos su información personal con terceros, excepto cuando sea necesario para los fines descritos anteriormente o cuando estemos legalmente obligados a hacerlo.
          <br/>
          <br/>

					<b>Derechos del Usuario:</b>
          <br/>
          <br/>

					Usted tiene derechos respecto a su información personal, incluido el acceso, corrección y eliminación de sus datos. Puede ejercer estos derechos comunicándose con nosotros a través de la información de contacto proporcionada al final de este aviso.

          <br/>
          <br/>
					<b>Cambios en este Aviso:</b>

          <br/>
          <br/>
					Nos reservamos el derecho de actualizar este Aviso de Privacidad en cualquier momento. Se le notificarán los cambios a través de la aplicación o por otros medios según corresponda.

          <br/>
          <br/>
					<b>Contacto:</b>

          <br/>
          <br/>
					Si tiene preguntas o inquietudes sobre este Aviso de Privacidad, puede contactarnos a través de:
          <br/>
          <br/>

					FAST ENGLISH
          <br/>
					Av. LindaVista 209, Col. Linda Vista, Guadalupe N.L.
          <br/>
					8121642470
          <br/>
					informes@fastenglish.com.mx
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialogAvisoPrivacidad = false"
          >
            Acepto
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

	</v-container>
</template>
<script>
	import Avataaars from 'vuejs-avataaars'
	import { mapActions, mapGetters } from 'vuex'

	// Dependencias
  const md5     = require('md5')

  // Componentes
  import Alerta          from '@/components/alertas/Alerta.vue'
  import MiCuenta        from '@/components/perfil/MiCuenta.vue'
  import Password        from '@/components/perfil/Password.vue'
  import Direccion       from '@/components/perfil/Direccion.vue'
  import AvataraUsuario  from '@/components/perfil/AvataraUsuario.vue'
  import Loader          from '@/components/alertas/Loader.vue'
  import Exci            from '@/components/calificaciones/Exci.vue'
  import TOEFL           from '@/components/calificaciones/Toefl.vue'
  import Notifi          from '@/components/alertas/Notifi.vue'
  import Reglamento      from '@/components/perfil/Reglamento.vue'
  import DatosFiscales    from '@/components/perfil/DatosFiscales.vue'


  // Mixins
  import  validarErrores from '@/mixins/validarErrores.js';

  export default {
  	components:{
  		Alerta,
  		MiCuenta,
  		Password,
  		Direccion,
  		Avataaars,
      DatosFiscales,
  		Loader,
  		AvataraUsuario,
  		Exci,
  		TOEFL,
  		Notifi,
			Reglamento
  	},

  	mixins:[validarErrores],

    data: () => ({
    	dialogAvisoPrivacidad: false,
    	length: 4,
      seccionMenu: 0,

    	editAvatar: false,

      avatar:'',
      ventana: 0,

      perfil: null,

      loader: true,
      cargar: false,

      avatarParamentro: {
      	editar: false
      },

      iderp: '',
	    curso: 0,
	    infoAlumno: []
    }),

    computed:{
    	...mapGetters( 'login', [ 'getUsuarioLMS', 'getDatosUsuarioLMS', 'getAvatar']),

    },

    created() {
    	this.cargar = true
    	if(!this.getDatosUsuarioLMS){
    		this.cargar = false
    		this.$router.push({name: 'RegistrarDatos'})
    	}
    	this.perfil = this.getDatosUsuarioLMS
      this.iderp = this.getUsuarioLMS.iderp
    	this.avatar = "https://ui-avatars.com/api/?background=1976d2&color=fff&rounded=true&format=svg&name=" +
      this.getUsuarioLMS.nombre + this.getUsuarioLMS.apellido_paterno
    	this.cargar = false,

		this.getInfoAlumno()
    },

    methods: {
    	...mapActions( 'login', [ 'grabarUsuario' ]),

    	habilitarVentana ( ventana ){
    		this.perfil = this.getDatosUsuarioLMS
    		this.ventana = ventana
    	},

      validarDatos () {
        return this.$refs.form.validate()
      },

      next () {
        this.seccionMenu = this.seccionMenu + 1 === this.length
          ? 0
          : this.seccionMenu + 1
      },
      prev () {
        this.seccionMenu = this.seccionMenu - 1 < 0
          ? this.length - 1
          : this.seccionMenu - 1
      },



	  getInfoAlumno() {
      this.infoAlumno = [];

      let payload = {
        id_alumno: this.getUsuarioLMS.id,
        id       : this.getUsuarioLMS.id,
      };

      this.$http.get(`reglamento.info.alumno/${payload.id_alumno}/${payload.id}`).then((response) => {
        this.infoAlumno = response.body;
        this.curso      = this.infoAlumno[0].tipo_curso;
        this.overlay    = false;
      }).catch((error) => {
        this.error = error.body;
        this.overlay = false;
      });
    },

    },
  }
</script>
<style scoped>
	.separacionAlta{
		padding-top: 100px !important;
		padding-left: 10px !important;
		padding-right: 10px !important;
	}

	.bordesCard{
		border-radius: 14px !important;
	}

	.shadowCard{
		border-radius: 15px !important;
		box-shadow: 0 20px 27px 0 rgba(0,0,0,0.15)  !important;
	}

	.cardUsuario{
		border-radius: 15px !important;
		box-shadow: 0 20px 27px 0 rgba(0,0,0,0.1)  !important;
	}

  .colorCurso{
  	color:  #5b5b5b;
  }
</style>
